<script>
export default {
  props: {
    value: String,
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: String,
    autofocus: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean,
    tabindex: String,
    manual: Boolean,
    number: Boolean,
  },



  data() {
    return {
      state: 'pending',
      internalLastCommitValue: '',
      hasUnCommit: false,
      internalInputValue: null,
      // firstSet: false,
    }
  },



  computed: {
    classes() {
      return {
        'dn-ls-text-field': true,
        [`dn-ls-text-field--has-un-commit`]: this.hasUnCommit,
      }
    },

    isReady() { return this.state === 'ready' },

    inputValue: {
      get() {
        return this.internalInputValue;
        // return this.value;
      },
      set(val) {
        this.internalInputValue = val;
        // this.$emit('input', val);
      }
    },

    lastCommitValue: {
      get() {
        return (this.internalLastCommitValue === undefined || this.internalLastCommitValue === null ? '' : this.internalLastCommitValue);
      },
      set(val) {
        this.internalLastCommitValue = val;
      }
    },

    isNumber() {
      return this.number || this.type === 'number';
    },
  },



  watch: {
    isReady() {
      this.$emit('ready', this.internalInputValue);
    },

    value() {
      this.internalInputValue = this.value;
    },
    internalInputValue() {
      if (this.manual) {
        this.updateHasUnCommit();
      } else {
        this.commit();
      }

      this.$emit('input', this.internalInputValue);
    },
    hasUnCommit() {
      this.$emit('change-has-un-commit', this.hasUnCommit);
    },
  },



  methods: {
    updateHasUnCommit() {
      let internalInputValue = this.internalInputValue;
      if (internalInputValue === null || internalInputValue === undefined) internalInputValue = '';
      this.hasUnCommit = this.lastCommitValue !== internalInputValue;
    },

    commit() {
      dn.$ls.set(this.name, this.internalInputValue);
      this.updateFromLs();
      this.$emit('commit', this.internalInputValue);
    },

    init() {
      this.updateFromLs();

      dn.window.on('show', () => {
        this.updateFromLs();
      });

      this.state = 'ready';
    },

    updateFromLs() {
      this.internalInputValue = dn.$ls.get(this.name, null);
      this.lastCommitValue = this.internalInputValue;
      this.hasUnCommit = false;
    },

    onInput(e) {
      if (this.isNumber) {
        const val = parseFloat(e.target.value);
        this.internalInputValue = isNaN(val) ? null : val;
      } else {
        this.internalInputValue = e.target.value;
      }
    },
    blur(e) {
      if (document.activeElement === this.$refs.input) {
        this.$refs.input.blur();
      }
      this.$emit('blur', e);
    },
    focus(e) {
      if (document.activeElement !== this.$refs.input) {
        this.$refs.input.focus();
      }
      this.$emit('focus', e);
    },
  },



  created() {
    this.init();
  },

  render(h) {
    if (!this.isReady) return;

    const listeners = this.$listeners || {};
    const nodeOptions = {
      class: this.classes,
      domProps: {
        type     : this.type,
        autofocus: this.autofocus,
        disabled : this.disabled,
        required : this.required,
        value    : this.internalInputValue,
        // pattern  : this.isNumber ? '\\d*' : void(0),
      },
      attrs: {
        ...this.$attrs,
        readonly: this.readonly,
        tabindex: this.tabindex,
      },
      on: Object.assign({}, listeners, {
        input: this.onInput,
        focus: this.focus,
        blur: this.blur,
        keyup: e => {
          if (e.which === 13) {
            this.$emit('enter', e);

            if (!this.manual) {
              this.commit();
              this.blur();
            } else {
              this.$nextTick(() => {
                if (!e.defaultPrevented) {
                  this.blur();
                }
              });
            }
          }
        },
      }),
      ref: 'input',
    };

    if (this.$attrs.min !== undefined || this.$attrs.max !== undefined) {
      nodeOptions.directives = [
        {
          name: 'number-range',
        }
      ];
    }

    if (this.placeholder) {
      nodeOptions.domProps.placeholder = this.placeholder;
    }

    const $node = h('input', nodeOptions);
    return $node;
  },
}
</script>


// WEBPACK FOOTER //
// LsTextField.vue?1ff8d6da